/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UploadedTravelCostNotification model module.
 * @module model/UploadedTravelCostNotification
 * @version 0.0.2
 */
class UploadedTravelCostNotification {
    /**
     * Constructs a new <code>UploadedTravelCostNotification</code>.
     * A notification about the processing of a travel cost entry from the uploaded data. This includes information about the processing status and any errors encountered.
     * @alias module:model/UploadedTravelCostNotification
     * @param type {module:model/UploadedTravelCostNotification.TypeEnum} The type of the processing notification for this travel cost entry.
     * @param message {String} A message providing additional information about the processing status, such as errors encountered or successful processing confirmation.
     */
    constructor(type, message) { 
        
        UploadedTravelCostNotification.initialize(this, type, message);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, type, message) { 
        obj['type'] = type;
        obj['message'] = message;
    }

    /**
     * Constructs a <code>UploadedTravelCostNotification</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UploadedTravelCostNotification} obj Optional instance to populate.
     * @return {module:model/UploadedTravelCostNotification} The populated <code>UploadedTravelCostNotification</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UploadedTravelCostNotification();

            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UploadedTravelCostNotification</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UploadedTravelCostNotification</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UploadedTravelCostNotification.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}

UploadedTravelCostNotification.RequiredProperties = ["type", "message"];

/**
 * The type of the processing notification for this travel cost entry.
 * @member {module:model/UploadedTravelCostNotification.TypeEnum} type
 */
UploadedTravelCostNotification.prototype['type'] = undefined;

/**
 * A message providing additional information about the processing status, such as errors encountered or successful processing confirmation.
 * @member {String} message
 */
UploadedTravelCostNotification.prototype['message'] = undefined;





/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
UploadedTravelCostNotification['TypeEnum'] = {

    /**
     * value: "success"
     * @const
     */
    "success": "success",

    /**
     * value: "warning"
     * @const
     */
    "warning": "warning",

    /**
     * value: "error"
     * @const
     */
    "error": "error"
};



export default UploadedTravelCostNotification;

